//     This code was generated by a Reinforced.Typings tool.
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.

import { CancelToken, AxiosRequestConfig, AxiosInstance } from 'axios';
import { IPurchasedLicence } from './IPurchasedLicence';

//element.Name=PurchaseController result.Name=PurchaseController element.FullName=Digita.Tustena.UI.Manage.WebApi.PurchaseController);
/** WebApiController: PurchaseController */
export class PurchaseController
{
	constructor (axios: AxiosInstance)
	{
		
		if (axios === null || axios === undefined) {
		    throw new Error('axios argument is required in PurchaseController constructor class, and cannot be empty or undefined');
		}
		this.axios = axios;
		
	}
	/** Name of axios $http interface */
	private axios: AxiosInstance;
	public Home(cancelToken?: CancelToken, axiosConfig?: AxiosRequestConfig) : Promise<string>
	{
		return (this.axios.get('Purchase/Home', { ...axiosConfig, cancelToken })).then(r => r.data);
	}
	public Get(cancelToken?: CancelToken, axiosConfig?: AxiosRequestConfig) : Promise<IPurchasedLicence>
	{
		return (this.axios.get('Purchase', { ...axiosConfig, cancelToken })).then(r => r.data);
	}
	public Update(value: number, cancelToken?: CancelToken, axiosConfig?: AxiosRequestConfig) : Promise<IPurchasedLicence>
	{
		return (this.axios.get('Purchase/Update?&value='+value, { ...axiosConfig, cancelToken })).then(r => r.data);
	}
	public Echo(payload: any, cancelToken?: CancelToken, axiosConfig?: AxiosRequestConfig) : Promise<any>
	{
		return (this.axios.post('Purchase/Echo', payload, { ...axiosConfig, cancelToken })).then(r => r.data);
	}
	public GetSwagger(honorAcceptLanguageHeader: boolean = false, bestPracticeOnly: boolean = true, cancelToken?: CancelToken, axiosConfig?: AxiosRequestConfig) : Promise<any>
	{
		return (this.axios.get('Purchase/GetSwagger?&honorAcceptLanguageHeader='+honorAcceptLanguageHeader+'&bestPracticeOnly='+bestPracticeOnly, { ...axiosConfig, cancelToken })).then(r => r.data);
	}
}
